/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/base-theme
 * @link https://github.com/scandipwa/base-theme
 */

import { PureComponent } from 'react';

import { ProductType } from 'Type/ProductList.type';

import ProductMeasurementsComponent from './ProductMeasurements.component';
import { CM_MEASUREMENT, INCHES_MEASUREMENT } from './ProductMeasurements.config';

/**
 * Product measurements container
 * @class ProductMeasurementsContainer
 * @namespace Scandipwa/Component/ProductMeasurements/Container */
export class ProductMeasurementsContainer extends PureComponent {
    static propTypes = {
        product: ProductType.isRequired
    };

    /**
     * Container props
     *
     * @returns {{measurementsAttributes: (string|unknown)[]}}
     */
    containerProps = () => ({
        measurementsAttributes: this.getMeasurementsAttributes()
    });

    /**
     * Removes unnecessary string from table html
     *
     * @param html
     * @returns {*}
     */
    removeUnnecessaryStrings(html) {
        const stringsToReplace = {
            NULL: '',
            '^(-(?!([1-99](Y|M))))$': '' // Doesn't remove "-" symbol for cases like 12-13Y or 1-3M
        };

        const regExp = new RegExp(Object.keys(stringsToReplace).join('|'), 'gi');

        return html && html.replace(regExp, (matched) => stringsToReplace[matched]);
    }

    /**
     * Returns measurements attributes
     *
     * @returns {[string, unknown]}
     */
    getMeasurementsAttributes() {
        const {
            product: {
                size_spec_table_imp = '',
                size_spec_table = ''
            }
        } = this.props;

        const measurementTables = {
            [CM_MEASUREMENT]: size_spec_table,
            [INCHES_MEASUREMENT]: size_spec_table_imp
        };

        return Object.entries(measurementTables).reduce((acc, [key, table]) => {
            if (table) {
                acc.push({
                    name: key,
                    value: this.removeUnnecessaryStrings(table)
                });
            }

            return acc;
        }, []);
    }

    render() {
        return (
            <ProductMeasurementsComponent
              { ...this.containerProps() }
            />
        );
    }
}

export default ProductMeasurementsContainer;
